// certificateStatus.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { userInfoService } from "../../services/userInfoService";
import { certificateStatusService } from "../../services/certificateStatusService";

// Define initial
const initialState = {
  loading: false,
  error: null,
  data: null,
  certificateStatusLoading: false,
};

// An asynchronous thunk for fetching certificate status
export const fetchCertificateStatus = createAsyncThunk(
  "profile/fetchCertificateStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await userInfoService.dashboard();
      return response?.data?.data;
    } catch (error) {
      // toast.error("Failed to fetch profile data.");
      return rejectWithValue(error.response.data);
    }
  }
);

// An asynchronous thunk for fetching certificate status
export const fetchCertificateApplicationDetails = createAsyncThunk(
  "profile/fetchCertificateApplicationDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response =
        await certificateStatusService.getCertificateApplicationDetails(id);
      return response?.data?.data;
    } catch (error) {
      toast.error("Failed to fetch profile data.");
      return rejectWithValue(error.response.data);
    }
  }
);

// Create the profile slice
const certicateStatusSlice = createSlice({
  name: "certificateStatus",
  initialState,
  reducers: {
    // Define additional reducers if needed
    setQualificationLoading: (state, action) => {
      state.qualificationLoading = action.payload;
    },
    logoutcertificate: (state, action) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCertificateStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCertificateStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCertificateStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCertificateApplicationDetails.pending, (state) => {
        state.certificateStatusLoading = true;
        state.error = null;
      })
      .addCase(
        fetchCertificateApplicationDetails.fulfilled,
        (state, action) => {
          state.certificateStatusLoading = false;
        }
      )
      .addCase(fetchCertificateApplicationDetails.rejected, (state, action) => {
        state.certificateStatusLoading = false;
        state.error = action.payload;
      });
  },
});

// Export the profile actions and reducer
export const {
  setQualificationLoading,
  handleExperienceLoading,
  logoutcertificate,
  setProfileSettingsLoading,
} = certicateStatusSlice.actions;
export default certicateStatusSlice.reducer;
